import { configureStore, getDefaultMiddleware } from 'redux-starter-kit'
import { reducer as userReducer, setUserToken } from './userSlice'
import { saveState } from './localStorage'
import { reducer as pricingReducer } from './pricingSlice'
import {
  reducer as localeReducer,
  setCurrency as setLocaleCurrency,
} from './localeSlice'
import { setToken } from 'js/api'
import { setCurrency } from 'js/pricing'

const saveAuthToken = store => next => action => {
  const { user } = store.getState()
  let userToken = null
  if (action.type === setUserToken.toString()) {
    userToken = action.payload
  } else {
    userToken = user.userToken
  }

  const token =
    user.profile && user.profile.id && userToken
      ? `${user.profile.id}:${userToken}`
      : null
  setToken(token)

  return next(action)
}

const saveCurrency = store => next => action => {
  const { locale } = store.getState()
  if (action.type === setLocaleCurrency.toString()) {
    setCurrency(action.payload)
  } else if (locale.currency) {
    setCurrency(locale.currency)
  }

  return next(action)
}

const store = configureStore(getStoreConfiguration())

function getStoreConfiguration(preloadedState) {
  return {
    reducer: {
      user: userReducer,
      pricing: pricingReducer,
      locale: localeReducer,
    },
    preloadedState,
    middleware: [...getDefaultMiddleware(), saveAuthToken, saveCurrency],
  }
}

saveState(store.getState())

export { getStoreConfiguration }
export default store
